import i18n from 'i18next';
import React, { useCallback, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useStyles from './NavigationBar.styles';
import { IconButton } from '../../buttons';
import FlyscanLogo from '../../icons/FlyscanLogo';
import LogoutIcon from '../../icons/LogoutIcon';

const NavigationBar = () => {
  const classes = useStyles();

  const history = useHistory();
  const location = useLocation();

  const { current: routes } = useRef([
    { path: '/missions', label: i18n.t('common.menu.navigationBar.missions') },
    { path: '/reports', label: i18n.t('common.menu.navigationBar.reports') },
    { path: '/clients', label: i18n.t('common.menu.navigationBar.clients') },
  ]);

  const [currentPath] = location.pathname.match(/^[^/]*(\/[^/]+)/) || [];

  const handleProfileClick = useCallback(() => history.push('/logout'), [history]);

  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        <FlyscanLogo />
      </div>

      <div className={classes.itemContainer}>
        {routes.map((route) => {
          const isCurrentLocation = currentPath === route.path;
          return (
            <div key={route.path} className={classes.item}>
              <Link className={isCurrentLocation ? classes.selectedLink : classes.link} to={route.path}>
                {route.label}
              </Link>
            </div>
          );
        })}
      </div>

      <div className={classes.actionsContainer}>
        <IconButton onClick={handleProfileClick} className={classes.imageContainer} classes={{ label: classes.iconButton }}>
          <LogoutIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default React.memo(NavigationBar);
